import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'highlight',
    standalone: true
})
export class HighlightPipe implements PipeTransform {
    transform(value: string | null | undefined, args: string | null | undefined): string {
        if (!args || !value) { return value ?? ""; }
        const escaped = args.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        var re = new RegExp(escaped, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
        return value.replace(re, "<mark>$&</mark>");
    }
}